// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoSt1 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.st_1";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoSt1 {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Aviso de privacitat",
                "cs": "Oznámení o ochraně soukromí",
                "da": "Privatlivsmeddelelse",
                "de": "Datenschutzerklärung",
                "el": "Δήλωση προστασίας προσωπικών δεδομένων",
                "en": "Privacy Notice",
                "es": "Aviso de privacidad",
                "eu": "Pribatutasun oharra",
                "fi": "Tietosuojailmoitus",
                "fr": "Avis de confidentialité",
                "gl": "Aviso de privacidade",
                "hi": "गोपनीयता सूचना",
                "hu": "Adatvédelmi tájékoztató",
                "it": "Informativa sulla privacy",
                "nl": "Privacyverklaring",
                "no": "Personvernerklæring",
                "pl": "Oświadczenie o ochronie prywatności",
                "pt": "Aviso de privacidade",
                "ro": "Notificare de confidențialitate",
                "ru": "Уведомление о конфиденциальности",
                "sv": "Integritetspolicy",
                "tr": "Gizlilik Bildirimi"
            },
            "defecto": "Privacy Notice"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
